import { render, staticRenderFns } from "./giftcard-stock.vue?vue&type=template&id=32c8f3d8"
import script from "./giftcard-stock.vue?vue&type=script&lang=js"
export * from "./giftcard-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports